import styled from "@emotion/styled";
import { theme } from "../../../utils/Theme";

export const Container = styled.div``;

export const FormStyle = styled.div`
  p:first-child {
    font-size: 14px;
    color: ${theme.neutral.n80};
  }
  display: grid;
  gap: 1rem;
`;
